import axios from "axios";

// 모든 admin API는 x-admin-id 헤더로 인증.
// 백엔드 requireAdmin 미들웨어가 헤더의 id로 DB에서 role을 확인.
function adminHeaders(adminUser) {
  return { "x-admin-id": adminUser?.id };
}

const BASE = process.env.REACT_APP_SERVER_URL;

export async function fetchUsers(adminUser) {
  const res = await axios.get(`${BASE}/api/admin/users`, {
    headers: adminHeaders(adminUser),
  });
  return res.data.users;
}

export async function fetchStats(adminUser) {
  const res = await axios.get(`${BASE}/api/admin/stats`, {
    headers: adminHeaders(adminUser),
  });
  return res.data;
}

// payload: { kla_expiration?: 'YYYY-MM-DD' | null, sle_expiration?: 'YYYY-MM-DD' | null }
export async function updateLicense(adminUser, userId, payload) {
  const res = await axios.patch(
    `${BASE}/api/admin/users/${userId}/license`,
    payload,
    { headers: adminHeaders(adminUser) }
  );
  return res.data;
}

export async function resetPassword(adminUser, userId, newPassword) {
  const res = await axios.post(
    `${BASE}/api/admin/users/${userId}/reset-password`,
    { new_password: newPassword },
    { headers: adminHeaders(adminUser) }
  );
  return res.data;
}

export async function deleteUser(adminUser, userId) {
  const res = await axios.delete(`${BASE}/api/admin/users/${userId}`, {
    headers: adminHeaders(adminUser),
  });
  return res.data;
}

export async function restoreUser(adminUser, userId) {
  const res = await axios.post(
    `${BASE}/api/admin/users/${userId}/restore`,
    {},
    { headers: adminHeaders(adminUser) }
  );
  return res.data;
}
